import React from 'react';

import './PaymentDetail.scss';

import { TripPaymentInfo, TripReceipt } from 'types/trip';

interface PaymentDetailProps {
  paymentInfo: TripPaymentInfo;
  receipt: TripReceipt;
}

export const PaymentDetail: React.FC<PaymentDetailProps> = ({ paymentInfo, receipt }) => {
  if (!receipt.hasPaidAmount && !receipt.unPaidAmount && !receipt.unRefundAmount) return null;
  return (
    <div className="history-detail-block history-payment-detail">
      <p className="history-detail-block__title">付款詳情</p>
      <div className="history-detail-block__content">
        {receipt.hasPaidAmount > 0 && paymentInfo.formattedTime && (
          <div className="history-payment-detail__block">
            <div className="history-payment-detail__item">
              <p>付款金額</p>
              <p>${receipt.hasPaidAmount}</p>
            </div>
            <p className="history-payment-detail__desc">{paymentInfo.formattedTime}</p>
          </div>
        )}
        {receipt.unPaidAmount > 0 && (
          <div className="history-payment-detail__block">
            <div className="history-payment-detail__item">
              <p>應付金額</p>
              <p className="primary">${receipt.unPaidAmount}</p>
            </div>
            <p className="history-payment-detail__desc">
              因行程費用異動，請重新付款。付款後前筆金額將立即退回。
            </p>
          </div>
        )}
        {receipt.unRefundAmount > 0 && (
          <div className="history-payment-detail__block">
            <div className="history-payment-detail__item">
              <p>應退金額</p>
              <p className={paymentInfo.refundTime ? '' : 'primary'}>${receipt.unRefundAmount}</p>
            </div>
            <p className="history-payment-detail__desc">
              {paymentInfo.refundTime
                ? `${paymentInfo.refundTime} 已退款`
                : '應退金額最晚將於三個工作天內完成退款'}
            </p>
          </div>
        )}
      </div>
    </div>
  );
};
